// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as PaymentMethod from "../../modules/PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as AccountingVendor from "../../modules/AccountingVendor.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as FiscalYearOpeningMonth from "../../modules/FiscalYearOpeningMonth.res.js";
import Accounting_figurePng from "./accounting_figure.png";
let figureUri = Accounting_figurePng;
function DateRangePreset(Params) {
  let values = ["Yesterday", "LastWeek", "LastMonth", {
    TAG: "CurrentFiscalYear",
    fiscalYearOpeningMonth: Params.fiscalYearOpeningMonth
  }, {
    TAG: "LastFiscalYear",
    fiscalYearOpeningMonth: Params.fiscalYearOpeningMonth
  }];
  let isEqual = (a, b) => {
    if (typeof a !== "object") {
      switch (a) {
        case "Yesterday":
          if (typeof b !== "object") {
            return b === "Yesterday";
          } else {
            return false;
          }
        case "LastWeek":
          if (typeof b !== "object") {
            return b === "LastWeek";
          } else {
            return false;
          }
        case "LastMonth":
          if (typeof b !== "object") {
            return b === "LastMonth";
          } else {
            return false;
          }
        case "NotDefined":
          if (typeof b !== "object") {
            return b === "NotDefined";
          } else {
            return false;
          }
      }
    } else {
      switch (a.TAG) {
        case "CurrentFiscalYear":
          if (typeof b !== "object" || b.TAG !== "CurrentFiscalYear") {
            return false;
          } else {
            return FiscalYearOpeningMonth.isEqual(a.fiscalYearOpeningMonth, b.fiscalYearOpeningMonth);
          }
        case "LastFiscalYear":
          if (typeof b !== "object" || b.TAG !== "LastFiscalYear") {
            return false;
          } else {
            return FiscalYearOpeningMonth.isEqual(a.fiscalYearOpeningMonth, b.fiscalYearOpeningMonth);
          }
        case "Custom":
          if (typeof b !== "object") {
            return false;
          } else {
            return b.TAG === "Custom";
          }
      }
    }
  };
  let isCustomOrNotDefined = value => {
    if (typeof value !== "object") {
      return value === "NotDefined";
    } else {
      return value.TAG === "Custom";
    }
  };
  let toString = (notDefinedPlaceholder, preset) => {
    let divider = ` → `;
    if (typeof preset !== "object") {
      switch (preset) {
        case "Yesterday":
          return I18n.t("Yesterday");
        case "LastWeek":
          return I18n.t("Last week");
        case "LastMonth":
          return I18n.t("Last month");
        case "NotDefined":
          return notDefinedPlaceholder;
      }
    } else {
      switch (preset.TAG) {
        case "CurrentFiscalYear":
          return I18n.t("Current fiscal year");
        case "LastFiscalYear":
          return I18n.t("Last fiscal year");
        case "Custom":
          let match = preset._0;
          let startDate = match[0];
          if (startDate === undefined) {
            return I18n.t("Custom");
          }
          let endDate = match[1];
          if (endDate !== undefined) {
            if (DateHelpers.isSameDay(startDate, endDate)) {
              return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate);
            } else {
              return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate) + divider + I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, endDate);
            }
          } else {
            return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate) + divider + ` …`;
          }
      }
    }
  };
  let getCurrentFiscalYearStart = (now, fiscalYearOpeningMonth) => {
    let fiscalOpeningMonth = FiscalYearOpeningMonth.toDateMonthJsIndex(fiscalYearOpeningMonth);
    if (now.getMonth() < fiscalOpeningMonth) {
      return now.getFullYear() - 1 | 0;
    } else {
      return now.getFullYear();
    }
  };
  let toDateRange = preset => {
    let now = new Date(Date.now());
    if (typeof preset !== "object") {
      switch (preset) {
        case "Yesterday":
          return [DateHelpers.subDays(DateHelpers.startOfDay(now), 1), DateHelpers.endOfDay(DateHelpers.subDays(now, 1))];
        case "LastWeek":
          return [DateHelpers.startOfWeek(DateHelpers.subWeeks(now, 1)), DateHelpers.endOfWeek(DateHelpers.subWeeks(now, 1))];
        case "LastMonth":
          return [DateHelpers.startOfMonth(DateHelpers.subMonths(now, 1)), DateHelpers.endOfMonth(DateHelpers.subMonths(now, 1))];
        case "NotDefined":
          return;
      }
    } else {
      switch (preset.TAG) {
        case "CurrentFiscalYear":
          let fiscalYearOpeningMonth = preset.fiscalYearOpeningMonth;
          let startDate = DateHelpers.startOfDay(new Date(getCurrentFiscalYearStart(now, fiscalYearOpeningMonth), FiscalYearOpeningMonth.toDateMonthJsIndex(fiscalYearOpeningMonth), 1));
          let endDate = DateHelpers.endOfMonth(DateHelpers.addMonths(startDate, 11));
          return [startDate, endDate];
        case "LastFiscalYear":
          let fiscalYearOpeningMonth$1 = preset.fiscalYearOpeningMonth;
          let startDate$1 = new Date(getCurrentFiscalYearStart(now, fiscalYearOpeningMonth$1) - 1 | 0, FiscalYearOpeningMonth.toDateMonthJsIndex(fiscalYearOpeningMonth$1), 1);
          let endDate$1 = DateHelpers.endOfMonth(DateHelpers.addMonths(startDate$1, 11));
          return [startDate$1, endDate$1];
        case "Custom":
          let match = preset._0;
          let startDate$2 = match[0];
          if (startDate$2 === undefined) {
            return;
          }
          let endDate$2 = match[1];
          if (endDate$2 !== undefined) {
            return [startDate$2, endDate$2];
          } else {
            return;
          }
      }
    }
  };
  let fromPartialDateRange = (range, presets) => {
    let startDateA = range[0];
    if (startDateA === undefined) {
      return "NotDefined";
    }
    let endDateA = range[1];
    if (endDateA === undefined) {
      return {
        TAG: "Custom",
        _0: range
      };
    }
    let preset = presets.find(preset => {
      let match = toDateRange(preset);
      if (match !== undefined && DateHelpers.isSameDay(startDateA, match[0])) {
        return DateHelpers.isSameDay(endDateA, match[1]);
      } else {
        return false;
      }
    });
    return Stdlib_Option.getOr(preset, {
      TAG: "Custom",
      _0: range
    });
  };
  return {
    values: values,
    isEqual: isEqual,
    isCustomOrNotDefined: isCustomOrNotDefined,
    toString: toString,
    getCurrentFiscalYearStart: getCurrentFiscalYearStart,
    toDateRange: toDateRange,
    fromPartialDateRange: fromPartialDateRange
  };
}
function AccountingPage$PageLayout(props) {
  return JsxRuntime.jsx(Page.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Card.make, {
        children: JsxRuntime.jsx(Stack.make, {
          children: props.children,
          space: "small",
          align: "center"
        }),
        grow: true,
        centerContent: true
      }),
      spaceTop: "large",
      grow: true
    }),
    variation: "compact",
    title: props.title
  });
}
let PageLayout = {
  make: AccountingPage$PageLayout
};
function endpoint(vendor, shopId) {
  let baseUrl = Env.sheetUrl() + "/accounting-export/" + shopId;
  if (vendor === "Excel") {
    return baseUrl + "/xlsx-format";
  } else {
    return baseUrl + "/ecr-format";
  }
}
function encodeBodyJson(shopId, dateRange) {
  return Json.encodeDict(Object.fromEntries([["shopId", Json.encodeString(shopId)], ["startDate", Json.encodeNumber(dateRange[0].getTime())], ["endDate", Json.encodeNumber(dateRange[1].getTime())], ["timeZone", Json.encodeString(I18n.timeZone)], ["accountingEntriesView", Json.encodeString("sales")]]));
}
function decodeInvalidRequestFailure(param) {
  let data = param.data;
  switch (param.kind) {
    case "AccountingPaymentExportItemMissingPaymentMethodConfiguration":
      let dict = Stdlib_Option.flatMap(data, Json.decodeDict);
      let paymentMethod = Json.flatDecodeDictField(dict, "paymentMethod", PaymentMethod.decodeFromJson);
      if (paymentMethod !== undefined) {
        return {
          TAG: "MissingPaymentMethodAccountFailure",
          _0: paymentMethod
        };
      } else {
        return "UnknownFailure";
      }
    case "InvalidFiscalExportDateRange":
      return "InvalidFiscalExportDateRangeFailure";
    case "InvalidCreditNoteTax":
    case "InvalidInvoiceTax":
    case "InvalidRefundReceiptTax":
      break;
    case "IsaComptaAccountNumberNotDefined":
    case "IsaComptaTaxCodeNotDefined":
      return "MissingConfigurationForIsacomptaVendorFailure";
    case "NotFoundAccountingExportConfiguration":
      return "NotFoundAccountingConfigurationFailure";
    default:
      return "UnknownFailure";
  }
  let dict$1 = Stdlib_Option.flatMap(data, Json.decodeDict);
  let name = Json.flatDecodeDictFieldString(dict$1, "name");
  let issueDate = Stdlib_Option.map(Json.flatDecodeDictFieldFloat(dict$1, "date"), prim => new Date(prim));
  if (name !== undefined && issueDate !== undefined) {
    return {
      TAG: "InvalidSaleTaxFailure",
      name: name,
      issueDate: issueDate
    };
  } else {
    return "UnknownFailure";
  }
}
function decodeRequestError(error) {
  if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
    return "UnknownFailure";
  } else {
    return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure), "UnknownFailure");
  }
}
function decodeResponse(result) {
  return Stdlib_Option.map(Json.flatDecodeDictFieldString(Json.decodeDict(result), "url"), prim => new URL(prim));
}
function make(shopId, dateRange, vendor) {
  return Future.flatMapOk(Future.mapError(Request.make(endpoint(vendor, shopId), "POST", {
    TAG: "JsonBody",
    _0: encodeBodyJson(shopId, dateRange)
  }, undefined, undefined), undefined, decodeRequestError), undefined, result => {
    let url = decodeResponse(result);
    return Future.value(url !== undefined ? {
      TAG: "Ok",
      _0: Primitive_option.valFromOption(url)
    } : {
      TAG: "Error",
      _0: "UnknownFailure"
    });
  });
}
let GetShopAccountingExportRequest = {
  endpoint: endpoint,
  encodeBodyJson: encodeBodyJson,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  decodeRequestError: decodeRequestError,
  decodeResponse: decodeResponse,
  make: make
};
let make$1 = React.memo(props => JsxRuntime.jsx(Modal.make, {
  children: JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t("accounting_page.export_confirmation_modal.text"),
      variation: "normal"
    }),
    spaceX: "xlarge",
    spaceY: "xxlarge"
  }),
  opened: props.opened,
  title: I18n.t("accounting_page.export_confirmation_modal.title"),
  abortButtonText: I18n.t("Cancel"),
  commitButtonText: I18n.t("Confirm"),
  commitButtonCallback: props.onCommit,
  onRequestClose: props.onRequestClose
}));
let AccountingExportRequestConfirmModal = {
  make: make$1
};
let styles = {
  img: {
    "height-kZKoxP": "height-xt7dq6l",
    "marginBottom-k1K539": "marginBottom-xod5an3",
    "marginTop-keoZOQ": "marginTop-xaci4zi",
    "maxWidth-ks0D6T": "maxWidth-xw5ewwj",
    $$css: "wino-gc:src/app/Accounting/AccountingPage.res.js:415"
  },
  responsiveImg: {
    "@media screen and (min-height: 900px)_marginBottom-k1o9pz": "marginBottom-xi3vq6s",
    "@media screen and (min-height: 900px)_maxWidth-kJh9Vq": "maxWidth-x1ucolwu",
    $$css: "wino-gc:src/app/Accounting/AccountingPage.res.js:421"
  },
  content: {
    "paddingTop-kLKAdn": "paddingTop-x889kno",
    $$css: "wino-gc:src/app/Accounting/AccountingPage.res.js:427"
  }
};
let now = new Date();
let startPreviousMonth = DateHelpers.startOfMonth(DateHelpers.subMonths(now, 1));
let endPreviousMonth = DateHelpers.endOfMonth(DateHelpers.subMonths(now, 1));
function make$2(shop, vendor, fiscalYearOpeningMonth) {
  return {
    submission: "NotAsked",
    shop: shop,
    dateRange: [startPreviousMonth, endPreviousMonth],
    fiscalYearOpeningMonth: fiscalYearOpeningMonth,
    vendor: vendor
  };
}
let State = {
  now: now,
  startPreviousMonth: startPreviousMonth,
  endPreviousMonth: endPreviousMonth,
  make: make$2
};
function AccountingPage(props) {
  let getShopAccountingConfigurationRequest = props.getShopAccountingConfigurationRequest;
  let configurationRoute = props.configurationRoute;
  let shops = Auth.useShops();
  let shop = Stdlib_Option.getOr(Auth.useActiveShop(), shops[0]);
  let captureEvent = SessionTracker.useCaptureEvent();
  let match = React.useState(() => AsyncData.notAsked());
  let setAsyncState = match[1];
  let asyncState = match[0];
  let match$1 = React.useState(() => false);
  let setExportRequestConfirmModalOpened = match$1[1];
  let navigate = Navigation.useNavigate();
  React.useEffect(() => {
    setAsyncState(AsyncData.toBusy);
    let future = getShopAccountingConfigurationRequest(shop.id);
    Future.get(future, shopAccountingConfiguration => {
      if (shopAccountingConfiguration.TAG !== "Ok") {
        return setAsyncState(param => ({
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: undefined
          }
        }));
      }
      let match = shopAccountingConfiguration._0;
      if (match === undefined) {
        return setAsyncState(param => ({
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: make$2(shop, "Excel", "January")
          }
        }));
      }
      if (match.isaComptaAccountNumber !== undefined) {
        let fiscalYearOpeningMonth = match.fiscalYearOpeningMonth;
        return setAsyncState(param => ({
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: make$2(shop, "IsaCompta", fiscalYearOpeningMonth)
          }
        }));
      }
      let fiscalYearOpeningMonth$1 = match.fiscalYearOpeningMonth;
      setAsyncState(param => ({
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: make$2(shop, "Excel", fiscalYearOpeningMonth$1)
        }
      }));
    });
    return () => Future.cancel(future);
  }, []);
  let pageTitle = I18n.t("Accounting entries");
  if (typeof asyncState === "object" && asyncState.TAG === "Done") {
    let state = asyncState._0;
    if (state.TAG !== "Ok") {
      return JsxRuntime.jsx(ResourceDetailsPage.make, {
        variation: "compact",
        title: pageTitle,
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Error"
        })
      });
    }
    let state$1 = state._0;
    let handleSubmit = param => {
      let fn = prevState => ({
        submission: "Loading",
        shop: prevState.shop,
        dateRange: prevState.dateRange,
        fiscalYearOpeningMonth: prevState.fiscalYearOpeningMonth,
        vendor: prevState.vendor
      });
      setAsyncState(prevState => AsyncResult.mapOk(prevState, fn));
      let match = state$1.vendor;
      if (match === "Excel") {
        captureEvent("download_accounting_excel_export_file");
      } else {
        captureEvent("download_accounting_isacompta_export_file");
      }
      Future.get(Future.flatMapOk(make(state$1.shop.id, state$1.dateRange, state$1.vendor), undefined, url => Future.mapError(TriggerDownload.fromUrl(undefined, url), undefined, () => "UnknownFailure")), result => {
        let fn = prevState => ({
          submission: {
            TAG: "Done",
            _0: result
          },
          shop: prevState.shop,
          dateRange: prevState.dateRange,
          fiscalYearOpeningMonth: prevState.fiscalYearOpeningMonth,
          vendor: prevState.vendor
        });
        setAsyncState(prevState => AsyncResult.mapOk(prevState, fn));
      });
    };
    let handleCloseBanner = () => {
      let fn = prevState => ({
        submission: "NotAsked",
        shop: prevState.shop,
        dateRange: prevState.dateRange,
        fiscalYearOpeningMonth: prevState.fiscalYearOpeningMonth,
        vendor: prevState.vendor
      });
      setAsyncState(prevState => AsyncResult.mapOk(prevState, fn));
    };
    let newrecord = {
      ...{
        className: "height-xt7dq6l marginBottom-xod5an3 marginTop-xaci4zi maxWidth-xw5ewwj marginBottom-xi3vq6s maxWidth-x1ucolwu",
        "data-style-src": "wino-gc:src/app/Accounting/AccountingPage.res.js:415; wino-gc:src/app/Accounting/AccountingPage.res.js:421"
      }
    };
    let newrecord$1 = {
      ...{
        className: "paddingTop-x889kno",
        "data-style-src": "wino-gc:src/app/Accounting/AccountingPage.res.js:427"
      }
    };
    let match$2 = state$1.submission;
    let tmp;
    if (typeof match$2 !== "object" || match$2.TAG !== "Done") {
      tmp = null;
    } else {
      let failure = match$2._0;
      if (failure.TAG === "Ok") {
        let message = I18n.t("Your accounting entries have been successfully exported.");
        tmp = JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Banner.make, {
            textStatus: {
              TAG: "Success",
              _0: message
            },
            onRequestClose: handleCloseBanner
          }),
          spaceBottom: "medium"
        });
      } else {
        let failure$1 = failure._0;
        let tmp$1;
        if (typeof failure$1 !== "object") {
          switch (failure$1) {
            case "MissingConfigurationForIsacomptaVendorFailure":
              tmp$1 = I18n.t("accounting.missing_configuration_for_isacompta_vendor_failure");
              break;
            case "NotFoundAccountingConfigurationFailure":
              tmp$1 = I18n.t("accounting.not_found_accounting_configuration_failure");
              break;
            case "InvalidFiscalExportDateRangeFailure":
              tmp$1 = I18n.t("The selected date range exceeds the boundaries of the fiscal year. Please ensure your start and end dates fall within a fiscal year.");
              break;
            case "UnknownFailure":
              tmp$1 = I18n.t("An unexpected error occured. Please try again or contact the support.");
              break;
          }
        } else {
          tmp$1 = failure$1.TAG === "InvalidSaleTaxFailure" ? I18n.template(I18n.t("accounting.invalid_sale_tax_failure{{name}}{{issueDate}}"), {
            name: failure$1.name,
            issueDate: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, failure$1.issueDate)
          }, undefined) : I18n.template(I18n.t("accounting.missing_payment_method_account_failure{{paymentMethod}}"), {
            paymentMethod: PaymentMethod.toLabel(failure$1._0).toLowerCase()
          }, undefined);
        }
        tmp = JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Banner.make, {
            textStatus: {
              TAG: "Danger",
              _0: tmp$1
            },
            onRequestClose: handleCloseBanner
          }),
          spaceBottom: "medium"
        });
      }
    }
    let fiscalYearOpeningMonth = state$1.fiscalYearOpeningMonth;
    let values = ["Yesterday", "LastWeek", "LastMonth", {
      TAG: "CurrentFiscalYear",
      fiscalYearOpeningMonth: fiscalYearOpeningMonth
    }, {
      TAG: "LastFiscalYear",
      fiscalYearOpeningMonth: fiscalYearOpeningMonth
    }];
    let isEqual = (a, b) => {
      if (typeof a !== "object") {
        switch (a) {
          case "Yesterday":
            if (typeof b !== "object") {
              return b === "Yesterday";
            } else {
              return false;
            }
          case "LastWeek":
            if (typeof b !== "object") {
              return b === "LastWeek";
            } else {
              return false;
            }
          case "LastMonth":
            if (typeof b !== "object") {
              return b === "LastMonth";
            } else {
              return false;
            }
          case "NotDefined":
            if (typeof b !== "object") {
              return b === "NotDefined";
            } else {
              return false;
            }
        }
      } else {
        switch (a.TAG) {
          case "CurrentFiscalYear":
            if (typeof b !== "object" || b.TAG !== "CurrentFiscalYear") {
              return false;
            } else {
              return FiscalYearOpeningMonth.isEqual(a.fiscalYearOpeningMonth, b.fiscalYearOpeningMonth);
            }
          case "LastFiscalYear":
            if (typeof b !== "object" || b.TAG !== "LastFiscalYear") {
              return false;
            } else {
              return FiscalYearOpeningMonth.isEqual(a.fiscalYearOpeningMonth, b.fiscalYearOpeningMonth);
            }
          case "Custom":
            if (typeof b !== "object") {
              return false;
            } else {
              return b.TAG === "Custom";
            }
        }
      }
    };
    let isCustomOrNotDefined = value => {
      if (typeof value !== "object") {
        return value === "NotDefined";
      } else {
        return value.TAG === "Custom";
      }
    };
    let toString = (notDefinedPlaceholder, preset) => {
      let divider = ` → `;
      if (typeof preset !== "object") {
        switch (preset) {
          case "Yesterday":
            return I18n.t("Yesterday");
          case "LastWeek":
            return I18n.t("Last week");
          case "LastMonth":
            return I18n.t("Last month");
          case "NotDefined":
            return notDefinedPlaceholder;
        }
      } else {
        switch (preset.TAG) {
          case "CurrentFiscalYear":
            return I18n.t("Current fiscal year");
          case "LastFiscalYear":
            return I18n.t("Last fiscal year");
          case "Custom":
            let match = preset._0;
            let startDate = match[0];
            if (startDate === undefined) {
              return I18n.t("Custom");
            }
            let endDate = match[1];
            if (endDate !== undefined) {
              if (DateHelpers.isSameDay(startDate, endDate)) {
                return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate);
              } else {
                return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate) + divider + I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, endDate);
              }
            } else {
              return I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate) + divider + ` …`;
            }
        }
      }
    };
    let getCurrentFiscalYearStart = (now, fiscalYearOpeningMonth) => {
      let fiscalOpeningMonth = FiscalYearOpeningMonth.toDateMonthJsIndex(fiscalYearOpeningMonth);
      if (now.getMonth() < fiscalOpeningMonth) {
        return now.getFullYear() - 1 | 0;
      } else {
        return now.getFullYear();
      }
    };
    let toDateRange = preset => {
      let now = new Date(Date.now());
      if (typeof preset !== "object") {
        switch (preset) {
          case "Yesterday":
            return [DateHelpers.subDays(DateHelpers.startOfDay(now), 1), DateHelpers.endOfDay(DateHelpers.subDays(now, 1))];
          case "LastWeek":
            return [DateHelpers.startOfWeek(DateHelpers.subWeeks(now, 1)), DateHelpers.endOfWeek(DateHelpers.subWeeks(now, 1))];
          case "LastMonth":
            return [DateHelpers.startOfMonth(DateHelpers.subMonths(now, 1)), DateHelpers.endOfMonth(DateHelpers.subMonths(now, 1))];
          case "NotDefined":
            return;
        }
      } else {
        switch (preset.TAG) {
          case "CurrentFiscalYear":
            let fiscalYearOpeningMonth = preset.fiscalYearOpeningMonth;
            let startDate = DateHelpers.startOfDay(new Date(getCurrentFiscalYearStart(now, fiscalYearOpeningMonth), FiscalYearOpeningMonth.toDateMonthJsIndex(fiscalYearOpeningMonth), 1));
            let endDate = DateHelpers.endOfMonth(DateHelpers.addMonths(startDate, 11));
            return [startDate, endDate];
          case "LastFiscalYear":
            let fiscalYearOpeningMonth$1 = preset.fiscalYearOpeningMonth;
            let startDate$1 = new Date(getCurrentFiscalYearStart(now, fiscalYearOpeningMonth$1) - 1 | 0, FiscalYearOpeningMonth.toDateMonthJsIndex(fiscalYearOpeningMonth$1), 1);
            let endDate$1 = DateHelpers.endOfMonth(DateHelpers.addMonths(startDate$1, 11));
            return [startDate$1, endDate$1];
          case "Custom":
            let match = preset._0;
            let startDate$2 = match[0];
            if (startDate$2 === undefined) {
              return;
            }
            let endDate$2 = match[1];
            if (endDate$2 !== undefined) {
              return [startDate$2, endDate$2];
            } else {
              return;
            }
        }
      }
    };
    let fromPartialDateRange = (range, presets) => {
      let startDateA = range[0];
      if (startDateA === undefined) {
        return "NotDefined";
      }
      let endDateA = range[1];
      if (endDateA === undefined) {
        return {
          TAG: "Custom",
          _0: range
        };
      }
      let preset = presets.find(preset => {
        let match = toDateRange(preset);
        if (match !== undefined && DateHelpers.isSameDay(startDateA, match[0])) {
          return DateHelpers.isSameDay(endDateA, match[1]);
        } else {
          return false;
        }
      });
      return Stdlib_Option.getOr(preset, {
        TAG: "Custom",
        _0: range
      });
    };
    newrecord$1.children = [tmp, JsxRuntime.jsxs(Inline.make, {
      children: [shops.length > 1 ? JsxRuntime.jsx(Auth.SelectSingleShopFilter.make, {
        value: state$1.shop,
        onChange: shop => {
          let fn = prevState => ({
            submission: prevState.submission,
            shop: shop,
            dateRange: prevState.dateRange,
            fiscalYearOpeningMonth: prevState.fiscalYearOpeningMonth,
            vendor: prevState.vendor
          });
          setAsyncState(prevState => AsyncResult.mapOk(prevState, fn));
        }
      }) : null, JsxRuntime.jsx(Select.make, {
        label: I18n.t("Format"),
        preset: "filter",
        sections: [{
          items: AccountingVendor.values.map(vendor => ({
            TAG: "Option",
            key: AccountingVendor.toLowercaseString(vendor),
            label: AccountingVendor.toLabel(vendor),
            value: vendor
          }))
        }],
        value: {
          TAG: "Single",
          _0: state$1.vendor
        },
        onChange: change => {
          if (change.TAG !== "Single") {
            return;
          }
          let vendor = change._0;
          let fn = prevState => ({
            submission: prevState.submission,
            shop: prevState.shop,
            dateRange: prevState.dateRange,
            fiscalYearOpeningMonth: prevState.fiscalYearOpeningMonth,
            vendor: vendor
          });
          setAsyncState(prevState => AsyncResult.mapOk(prevState, fn));
        }
      }), JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state$1.dateRange,
        label: I18n.t("Period"),
        placeholder: I18n.t("Select a period"),
        hideResetButton: true,
        preset: {
          values: values,
          isCustomOrNotDefined: isCustomOrNotDefined,
          toString: toString,
          toDateRange: toDateRange,
          fromPartialDateRange: fromPartialDateRange,
          isEqual: isEqual
        },
        onChange: dateRange => Stdlib_Option.forEach(dateRange, value => {
          let fn = prevState => ({
            submission: prevState.submission,
            shop: prevState.shop,
            dateRange: value,
            fiscalYearOpeningMonth: prevState.fiscalYearOpeningMonth,
            vendor: prevState.vendor
          });
          setAsyncState(prevState => AsyncResult.mapOk(prevState, fn));
        }),
        triggerLabelDisplay: "showDateRange"
      }), JsxRuntime.jsx(Button.make, {
        label: I18n.t("Export"),
        variant: "solid",
        tone: "brand",
        size: "legacy_large",
        pending: AsyncData.isBusy(state$1.submission),
        icon: "export",
        onPress: () => setExportRequestConfirmModalOpened(param => true)
      }), JsxRuntime.jsx(make$1, {
        opened: match$1[0],
        onRequestClose: () => setExportRequestConfirmModalOpened(param => false),
        onCommit: handleSubmit
      })],
      space: "normal",
      align: "center"
    }), JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("accounting_main.description"),
          align: "center"
        }), JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(Button.make, {
            label: I18n.t("Setup my accounting accounts"),
            variant: "subtle",
            size: "large",
            icon: "edit",
            onPress: () => navigate(undefined, configurationRoute(state$1.shop.id, state$1.vendor))
          }),
          align: "center"
        })],
        space: "small",
        align: "center"
      }),
      spaceTop: "medium"
    }), JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal",
        spacing: "none"
      }),
      spaceTop: "normal",
      spaceBottom: "xlarge"
    }), JsxRuntime.jsx(Stack.make, {
      children: JsxRuntime.jsx(TextAction.make, {
        text: I18n.t("Learn more about accounting entries"),
        onPress: () => HelpCenter.showArticle(HelpCenter.setupAndExportAccountingEntries)
      }),
      align: "center"
    })];
    return JsxRuntime.jsxs(AccountingPage$PageLayout, {
      title: pageTitle,
      children: [JsxRuntime.jsx("img", (newrecord.src = figureUri, newrecord)), JsxRuntime.jsx(Title.make, {
        children: I18n.t("Export my accounting entries"),
        level: 2,
        align: "center"
      }), JsxRuntime.jsxs("div", newrecord$1)]
    });
  }
  return JsxRuntime.jsx(ResourceDetailsPage.make, {
    variation: "compact",
    title: pageTitle,
    children: JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    })
  });
}
let make$3 = AccountingPage;
export { figureUri, DateRangePreset, PageLayout, GetShopAccountingExportRequest, AccountingExportRequestConfirmModal, styles, State, make$3 as make };
/* figureUri Not a pure module */